// App_style.js
import { zoom, zoomBoxShadow, getResponsiveZoom } from './zoomUtils.js';

export const appStyles = {
  app: {
    width: '100vw',
    minHeight: '100vh',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'var(--primary-dark)',
    padding: zoom('20px') + ' 0'
  },

  appMobile: {
    alignItems: 'flex-start'
  },

  appAfter: {
    content: "''",
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    boxShadow: zoomBoxShadow([
      'inset 0 0 40vmin rgba(0,0,0,0.2)',
      'inset 0 0 60vmin rgba(0,0,0,0.3)',
      'inset 0 0 80vmin rgba(0,0,0,0.4)'
    ]),
    pointerEvents: 'none',
    zIndex: 1000,
    transition: 'box-shadow 0.2s ease-out'
  },

  flowContainer: {
    position: 'relative',
    zIndex: 10,
    overflow: 'visible',
    display: 'grid',
    gridTemplateColumns: 'repeat(10, 1fr)',
    gridTemplateRows: `repeat(3, minmax(${zoom('50px')}, auto))`,
    gap: zoom('20px'),
    width: zoom('1000px'),
    height: zoom('400px')
  },

  flowContainerMobile: {
    gridTemplateColumns: `repeat(5, minmax(${zoom('60px')}, auto))`,
    gridTemplateRows: '1fr',
    gap: zoom('40px'),
    padding: zoom('20px'),
    width: zoom('350px'),
    height: 'auto'
  }
};

export const getResponsiveStyles = () => {
  const { isMobile } = getResponsiveZoom();
  
  return {
    app: {
      ...appStyles.app,
      ...(isMobile && window.innerHeight <= 1150 ? appStyles.appMobile : {})
    },
    flowContainer: {
      ...appStyles.flowContainer,
      ...(isMobile ? appStyles.flowContainerMobile : {})
    }
  };
};